import { BASE_URL } from "../utils/helpers";

export const authenticatedFetch = async <T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> => {
  const token = localStorage.getItem("_token");
  if (!token) {
    window.location.href = "/login";
    throw new Error("No authentication token");
  }

  const url = `${BASE_URL}/${endpoint.replace(/^\/+/, "")}`;

  const response = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });

  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem("_token");
      window.location.href = "/login";
    }
    const text = await response.text();
    throw new Error(text || response.statusText);
  }

  // For DELETE requests, some APIs return no content
  if (
    response.status === 204 ||
    response.headers.get("content-length") === "0"
  ) {
    return {} as T;
  }

  return response.json();
};
